import { TableCell, TableRow, styled, blend } from '@gogame/components';

export const TableRowActivityTypes = styled(TableRow)`
  background: ${({
    theme,
    type,
    'data-hover': dataHover,
    'data-selected': dataSelected,
  }) =>
    dataSelected
      ? blend(
          theme.palette.background.paper,
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      : dataHover
        ? blend(
            theme.palette.background.paper,
            theme.palette.action.active,
            theme.palette.action.hoverOpacity
          )
        : type === '2'
          ? blend(
              theme.palette.background.paper,
              theme.palette.action.active,
              theme.palette.action.hoverOpacity
            )
          : theme.palette.background.paper} !important;
`;

export const TableCellDefaultBackground = styled(TableCell)`
  background: ${({ 'data-hover': dataHover, 'data-selected': dataSelected }) =>
    dataSelected ? 'darkblue' : dataHover ? 'blue' : 'yellow'};
  //'#eaf4fe' #ececec #fff
`;

export const TableCellStyled = styled(TableCell)`
  color: ${({ error, theme }) =>
    error ? `${theme.palette.error.main} !important` : null};
`;
